export default __webpack_public_path__ + "static/media/phone_android.abaed5be.svg";